import React, { useState } from 'react';

/* Blog cover image — real <img>, using only the site's existing theme
   colors (--red / --blue / --ink and their deep variants) for the badge,
   scrim, and the placeholder tint shown until an image is dropped in. */

export default function BlogCoverArt({ image, alt, rgb, badge, meta, height = '100%', compact = false }) {
  const [errored, setErrored] = useState(false);
  const showImage = !!image && !errored;

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        height,
        width: '100%',
        flexShrink: 0,
        background: `linear-gradient(150deg, rgba(${rgb},0.9) 0%, rgba(${rgb},0.55) 55%, var(--ink) 130%)`,
      }}
    >
      {showImage && (
        <img
          src={image}
          alt={alt || ''}
          loading="lazy"
          onError={() => setErrored(true)}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}

      {/* Scrim so badge/meta text stays legible over any image */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.30) 0%, rgba(0,0,0,0) 34%, rgba(0,0,0,0) 62%, rgba(0,0,0,0.5) 100%)',
        }}
      />

      {badge && (
        <span
          style={{
            position: 'absolute',
            top: compact ? 12 : 20,
            left: compact ? 12 : 20,
            padding: compact ? '5px 12px' : '7px 16px',
            background: 'rgba(255,255,255,0.14)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            border: `1px solid rgba(${rgb},0.55)`,
            borderRadius: 999,
            fontSize: compact ? 10 : 11,
            fontWeight: 700,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: 'white',
          }}
        >
          {badge}
        </span>
      )}

      {meta && (
        <div
          style={{
            position: 'absolute',
            bottom: compact ? 12 : 18,
            left: compact ? 12 : 20,
            right: compact ? 12 : 20,
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: compact ? 10.5 : 12,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.85)',
          }}
        >
          <span>{meta[0]}</span>
          <span>{meta[1]}</span>
        </div>
      )}
    </div>
  );
}
